export default {
  taskList: state => state.taskList,
  taskListPageCount: state => state.taskListPageCount,
  updatedDataUi: state => state.updatedDataUi,
  taskCount: state => state.taskCount
}
